import React, { useState } from 'react';

function AdminDashboard({ user }) {
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('employee');
  const [message, setMessage] = useState(null);

  const handleInvite = async () => {
    if (!email || !role) {
      setMessage('Email and role are required.');
      return;
    }
    try {
      const res = await fetch('https://kindred-cloudflare.shepherdn.workers.dev/admin/invite', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, role })
      });
      const result = await res.json();
      if (res.ok) {
        setMessage(`✅ Invite sent to ${email}`);
        setEmail('');
        setRole('employee');
      } else {
        setMessage(result.error || 'Failed to send invite.');
      }
    } catch (err) {
      setMessage('Error sending invite.');
      console.error(err);
    }
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h1>Welcome, {user?.name || 'Admin'}!</h1>
      <p>You are viewing the <strong>Admin Dashboard</strong>.</p>

      {/* System Overview */}
      <section style={{ marginTop: '2rem' }}>
        <h2>System Overview</h2>
        <p>Quick metrics about users, tasks, and system health.</p>
      </section>

      {/* User Management */}
      <section style={{ marginTop: '2rem' }}>
        <h2>Manage Users</h2>
        <p>Add, edit, deactivate, or remove employees, resellers, and admins.</p>

        <div style={{ marginTop: '1rem', padding: '1rem', border: '1px solid #ccc', borderRadius: '8px' }}>
          <h3>Invite New User</h3>
          <label>Email: </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ marginRight: '1rem' }}
          />
          <label>Role: </label>
          <select
            value={role}
            onChange={(e) => setRole(e.target.value)}
            style={{ marginRight: '1rem' }}
          >
            <option value="employee">Employee</option>
            <option value="reseller">Reseller</option>
          </select>
          <button onClick={handleInvite}>Send Invite</button>
          {message && <p style={{ marginTop: '0.5rem' }}>{message}</p>}
        </div>
      </section>

      {/* Reseller and Employee Monitoring */}
      <section style={{ marginTop: '2rem' }}>
        <h2>Monitor Teams</h2>
        <p>View performance stats, organization charts, and reseller activity.</p>
      </section>

      {/* Financial Center */}
      <section style={{ marginTop: '2rem' }}>
        <h2>Financial Center</h2>
        <p>Review, approve, or reject invoicing requests. Generate financial reports.</p>
      </section>

      {/* Settings and Configurations */}
      <section style={{ marginTop: '2rem' }}>
        <h2>System Settings</h2>
        <p>Manage system-wide configurations, permissions, and customizations.</p>
      </section>
    </div>
  );
}

export default AdminDashboard;
